import { EMPTY_ARRAY_LENGTH } from '@/constants/defaults';
import { UniqueId } from '@/types/ui.types';
import { ViewLayoutType } from '@/types/view.types';

export const isGroupByAssignmentsLayout = (layout: ViewLayoutType): boolean => {
  const validLayouts = [ViewLayoutType.STANDARD, ViewLayoutType.COLUMNS, ViewLayoutType.CALENDAR, ViewLayoutType.GANTT];

  return validLayouts.includes(layout);
};

export const isDemandTallyId = (id: string): boolean => {
  return isNaN(Number.parseInt(id));
};

export const getId = (key: string | UniqueId): string | number => {
  let id: string | number = key;

  if (!Number.isNaN(Number(key))) {
    id = Number(key);
  }
  return id;
};

export const isRecord = (target: unknown) => target && typeof target === 'object' && !Array.isArray(target);

/**
 * Checks if a value is empty (null, undefined, empty string, empty array, or empty object)
 * @param value - The value to check
 * @returns true if the value is null, undefined, empty string, empty array, or empty object
 */
export const isEmpty = (value: unknown): boolean => {
  if (value === null || value === undefined) {
    return true;
  }

  if (typeof value === 'string' && value.trim() === '') {
    return true;
  }

  if (Array.isArray(value) && value.length === EMPTY_ARRAY_LENGTH) {
    return true;
  }

  if (typeof value === 'object' && Object.keys(value).length === EMPTY_ARRAY_LENGTH) {
    return true;
  }

  return false;
};
